import { FC } from 'react'

import { ISvgClass } from '../interface'

const BellIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path
          d="M2446 5108 c-68 -13 -181 -67 -243 -116 -66 -53 -139 -156 -171 -241 -21 -54 -26 -87 -29 -186 l-3 -120 -72 -31 c-205 -87 -372 -198 -524 -349 -253 -250 -402 -531 -471 -885 -14 -71 -18 -184 -22 -708 -6 -602 -7 -624 -25 -638 -11 -8 -31 -14 -45 -14 -123 -2 -284 -62 -383 -144 -208 -170 -268 -467 -143 -705 69 -130 180 -226 325 -279 l75 -27 550 -3 c414 -2 551 -6 557 -15 4 -7 8 -22 8 -35 0 -41 50 -175 90 -243 97 -164 247 -280 440 -340 99 -31 290 -33 390 -5 169 49 332 166 425 306 64 96 91 164 120 303 l5 27 523 0 c420 0 536 3 592 15 278 58 468 308 452 595 -11 214 -132 391 -334 487 -65 31 -189 62 -254 63 -14 0 -34 6 -45 14 -18 14 -19 35 -24 623 -6 583 -7 612 -29 718 -58 279 -176 532 -349 746 -171 213 -446 418 -672 503 l-45 17 0 117 c0 143 -22 216 -96 321 -128 183 -350 272 -573 229z m209 -342 c82 -38 135 -115 135 -195 l0 -39 -157 5 c-87 3 -191 1 -230 -4 l-73 -9 0 43 c0 84 52 161 135 199 64 31 126 31 190 0z m218 -594 c425 -110 776 -434 927 -857 73 -206 73 -202 79 -895 l6 -625 24 -58 c15 -37 44 -81 82 -121 75 -80 144 -113 269 -127 107 -12 147 -27 202 -77 53 -48 78 -102 78 -172 0 -94 -51 -178 -135 -223 l-40 -22 -1784 -3 c-1209 -1 -1795 1 -1822 8 -99 27 -179 134 -179 239 0 71 25 125 78 173 56 50 95 65 203 77 173 19 291 104 352 253 21 52 22 66 28 698 7 698 5 681 66 865 113 348 386 647 724 795 186 82 341 111 564 106 138 -4 176 -8 278 -34z m87 -3529 c0 -37 -52 -126 -105 -182 -165 -173 -425 -173 -590 0 -31 32 -67 82 -80 111 -45 96 -80 88 375 88 374 0 400 -1 400 -17z"
          fill="inherit"
        />
      </g>
    </svg>
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.0"
    //   width="24px"
    //   height="24px"
    //   viewBox="0 0 512.000000 512.000000"
    //   {...props}
    // >
    //   <g
    //     transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    //     fill="inherit"
    //     stroke="none"
    //   >
    //     <path
    //       d="M2453 5105 c-141 -38 -250 -141 -299 -280 -13 -37 -19 -97 -23 -228 l-6 -179 -85 -33 c-194 -74 -360 -178 -502 -313 -185 -177 -314 -378 -392 -613 -68 -203 -68 -204 -76 -764 -8 -535 -12 -586 -60 -760 -28 -98 -53 -161 -109 -273 -72 -143 -161 -261 -297 -397 -155 -154 -169 -180 -169 -305 0 -80 4 -102 23 -138 35 -66 88 -119 150 -149 l57 -28 577 -3 578 -3 6 -27 c32 -148 91 -264 181 -361 142 -155 304 -234 507 -248 219 -15 412 61 576 226 112 113 168 218 204 383 l6 27 578 3 577 3 57 28 c62 30 115 83 150 149 19 36 23 58 23 138 0 126 -15 152 -169 305 -206 205 -332 413 -407 672 -46 161 -51 225 -59 758 -8 559 -9 561 -75 761 -78 236 -208 440 -393 616 -142 135 -308 239 -502 313 l-85 33 -6 179 c-5 144 -10 189 -26 235 -78 212 -298 330 -510 273z m210 -227 c23 -13 55 -42 72 -66 30 -43 30 -45 33 -190 l3 -147 -210 0 -211 0 0 133 c0 97 4 143 15 170 49 116 186 162 298 100z m129 -634 c457 -87 837 -417 982 -854 57 -173 58 -187 66 -735 7 -547 11 -593 67 -785 85 -293 267 -589 478 -776 95 -85 112 -123 79 -185 -32 -63 89 -59 -1904 -59 -1993 0 -1872 -4 -1904 59 -33 62 -16 100 79 185 211 187 393 483 478 776 55 191 59 238 67 785 8 547 9 563 66 735 98 295 315 557 592 714 134 76 318 135 484 156 93 11 264 4 370 -16z m284 -3631 c-14 -60 -75 -171 -122 -222 -103 -114 -233 -172 -389 -174 -156 -1 -292 58 -395 170 -50 55 -111 164 -126 226 l-6 27 522 0 522 0 -6 -27z"
    //       fill="inherit"
    //     />
    //   </g>
    // </svg>
  )
}

export default BellIcon
